import React from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';
import { NavLink } from 'react-router-dom';

import { ReactComponent as RegistrationImg } from '../icons/offer_zakladanie.svg';
import { ReactComponent as ServicesImg } from '../icons/offer_uslugi.svg';
import { ReactComponent as LaunchIcon } from '../icons/offer_uruchamianie.svg';
import tempImg from '../images/contact_navImg.png';

const offers = [
  {
    title: 'Spółki',
    description: 'Zakładanie spółek',
    image: RegistrationImg,
    style: 'offer-img-left'
  },
  {
    title: 'Usługi',
    description: 'Usługi doradczo-konsultingowe',
    image: ServicesImg,
    style: ''
  },
  {
    title: 'Działalność',
    description: 'Uruchamianie działalności gospodarczej',
    image: LaunchIcon,
    style: 'offer-img-right'
  }
];

const Offer = () => {
  return (
    <section id="offer">
      <img className={getTheme('template-img')} src={tempImg} alt={'offer'} />
      <div className="container">
        <div className="offer-row">
          {offers.map((offer, i) => (
            <div className="col-md-4 offer-height" key={i}>
              <div className={offer.style + ' ' + getTheme('offer-content')}>
                <offer.image className="offer-img" />
                <h3> {translate(offer.title)}</h3>
                <p> {translate(offer.description)}</p>
                <div className='offer-btn-row'>
                  <NavLink exact to='/Contact' className={getTheme('offer-btn')}>{translate('Zapytaj o szczegóły')}</NavLink>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offer;
